import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import aboutData from '../data/about.json';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-paper">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          
          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-[3rem] overflow-hidden shadow-2xl aspect-square ring-8 ring-white/50">
              <img 
                src={aboutData.image} 
                alt="Our Team" 
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="absolute top-12 -right-6 md:-right-10 bg-brand p-8 rounded-[2rem] shadow-2xl text-center text-white min-w-[160px] transform hover:rotate-3 transition-transform">
              <span className="block text-5xl font-black mb-1">15+</span>
              <span className="text-xs font-bold uppercase tracking-widest opacity-80">Years of<br/>Excellence</span>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="text-brand font-black uppercase tracking-[0.2em] text-xs mb-3 block">{t('about.tagline')}</span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8">
              {t('about.title')}
            </h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed font-medium">
              {t('about.description')}
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-10 border-t border-gray-200">
              {aboutData.stats.map((stat) => (
                <div key={stat.id}>
                  <div className="text-4xl font-black text-brand mb-2">{stat.number}</div>
                  <div className="text-sm text-gray-500 font-bold uppercase tracking-wider">{t(`about.stats.${stat.id}`)}</div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;